import React from 'react';

import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MainComponent from './commons/main/mainComponent';

const styles = {
    fontSize: '5rem',
    fontWeight: '600',
    marginBottom: '30px',
};

const Notfound = () => {
    const { t } = useTranslation();

    return (
        <MainComponent>
            <div className="text-center">
                <h1 style={styles}>404</h1>
                <Link to="/" className="btn btn-success">
                    {t('common.backHome')}
                </Link>
            </div>
        </MainComponent>
    );
};

export default Notfound;
